<span class="description">
  {{ 'AUTOMATIONS.EDITOR.TRIGGERS.USER_ONLINE.USER_ONLINE' | translate : (translationParams | async) }}
  <br />
  <br />
  <glxy-alert type="warning">
    <strong>
      {{ 'AUTOMATIONS.EDITOR.TRIGGERS.USER_ONLINE.WARN_TITLE' | translate : (translationParams | async) }}
    </strong>
    {{ 'AUTOMATIONS.EDITOR.TRIGGERS.USER_ONLINE.MORE_INFO_V2' | translate : (translationParams | async) }}
  </glxy-alert>
</span>
